"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryUtilities = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const crypto = require("crypto");
const fs = require("fs");
const path = require("path");
const util_1 = require("util");
const CommandExecutor_1 = require("../Utils/CommandExecutor");
const EventStreamEvents_1 = require("./EventStreamEvents");
class TelemetryUtilities {
    static HashData(dataToHash) {
        if (!dataToHash) {
            return '';
        }
        const hasher = crypto.createHash('sha256');
        const utf8Bytes = new util_1.TextEncoder().encode(dataToHash.toUpperCase());
        const hashedData = hasher.update(utf8Bytes).digest('hex').toLowerCase();
        return hashedData;
    }
    /**
     *
     * @param stringWithPaths The string that may contain paths to hash.
     * @returns The same string but with all paths in it hashed.
     * @remarks Will not hash a filename as it is a leaf file system object. It needs to be a path with at least one directory.
     * That's what we'd like to hash. (E.g. dotnet-install.ps1 is not needed to hash.)
     */
    static HashAllPaths(stringWithPaths) {
        let hashedPathsString = ``;
        stringWithPaths.split(' ').forEach(word => {
            const convertedLine = word !== path.basename(word) && fs.existsSync(word) && (fs.lstatSync(word).isFile() || fs.lstatSync(word).isDirectory())
                ? TelemetryUtilities.HashData(word) : word;
            hashedPathsString = `${hashedPathsString} ${convertedLine}`;
            return hashedPathsString;
        });
        return hashedPathsString;
    }
    static setDotnetSDKTelemetryToMatch(isExtensionTelemetryEnabled, extensionContext, acquisitionContext, utilityContext) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!TelemetryUtilities.isTelemetryEnabled(isExtensionTelemetryEnabled, utilityContext)) {
                TelemetryUtilities.logTelemetryChange(`Before disabling .NET SDK telemetry:`, isExtensionTelemetryEnabled, acquisitionContext === null || acquisitionContext === void 0 ? void 0 : acquisitionContext.eventStream, utilityContext);
                yield new CommandExecutor_1.CommandExecutor(acquisitionContext, utilityContext).setEnvironmentVariable('DOTNET_CLI_TELEMETRY_OPTOUT', 'true', extensionContext, `Telemetry is disabled for the .NET Install Tool, but we were unable to turn off the .NET SDK telemetry.
To disable .NET SDK telemetry, set the environment variable DOTNET_CLI_TELEMETRY_OPTOUT to true.`, `The .NET Install Tool will not collect telemetry. However, the .NET SDK does collect telemetry.
To disable .NET SDK telemetry, set the environment variable DOTNET_CLI_TELEMETRY_OPTOUT to true.`);
                TelemetryUtilities.logTelemetryChange(`After disabling .NET SDK telemetry:`, isExtensionTelemetryEnabled, acquisitionContext === null || acquisitionContext === void 0 ? void 0 : acquisitionContext.eventStream, utilityContext);
            }
            else {
                utilityContext.ui.showWarningMessage(`The .NET tools collect usage data in order to help us improve your experience. It is collected by Microsoft and shared with the community. You can opt-out of telemetry by setting the DOTNET_CLI_TELEMETRY_OPTOUT environment variable to '1' or 'true' using your favorite shell.
Read more about .NET CLI Tools telemetry: https://aka.ms/dotnet-cli-telemetry`, () => { });
                TelemetryUtilities.logTelemetryChange(`Unchanged Telemetry Settings.`, isExtensionTelemetryEnabled, acquisitionContext === null || acquisitionContext === void 0 ? void 0 : acquisitionContext.eventStream, utilityContext);
            }
        });
    }
    static isDotnetSDKTelemetryDisabled() {
        const optOut = process.env.DOTNET_CLI_TELEMETRY_OPTOUT;
        return optOut && optOut !== 'false' && optOut !== '0';
    }
    static isTelemetryEnabled(isExtensionTelemetryEnabled, utilityContext) {
        const isVSCodeTelemetryEnabled = utilityContext.vsCodeEnv.isTelemetryEnabled();
        return isVSCodeTelemetryEnabled && isExtensionTelemetryEnabled;
    }
    static logTelemetryChange(changeMessage, isExtensionTelemetryEnabled, eventStream, utilityContext) {
        eventStream === null || eventStream === void 0 ? void 0 : eventStream.post(new EventStreamEvents_1.DotnetTelemetrySettingEvent(`Telemetry Setting Change: ${changeMessage}
.NET SDK Setting: ${!TelemetryUtilities.isDotnetSDKTelemetryDisabled()},
Extension Setting: ${isExtensionTelemetryEnabled}
VS Code Setting: ${utilityContext.vsCodeEnv.isTelemetryEnabled()}.`));
    }
}
exports.TelemetryUtilities = TelemetryUtilities;
//# sourceMappingURL=TelemetryUtilities.js.map